(() => {
  const selectors = '.product-info__description img, .product-info__accordion img';
  const widths = [400, 600, 800, 1000, 1200];

  const sizedUrl = (source, width) => {
    const url = new URL(source, window.location.href);
    url.searchParams.set('width', String(width));
    return url.href;
  };

  const optimize = (root = document) => {
    root.querySelectorAll(selectors).forEach((image) => {
      if (image.dataset.vdResponsive === 'true') return;
      const source = image.getAttribute('src');
      if (!source) return;

      let url;
      try { url = new URL(source, window.location.href); } catch { return; }
      const isShopifyFile = /(^|\.)shopify(?:cdn)?\.com$/.test(url.hostname)
        || (url.hostname === window.location.hostname && url.pathname.includes('/cdn/shop/files/'));
      if (!isShopifyFile || !url.pathname.includes('/files/')) return;

      image.loading = 'lazy';
      image.decoding = 'async';
      if (!image.hasAttribute('srcset')) {
        image.srcset = widths.map((width) => `${sizedUrl(source, width)} ${width}w`).join(', ');
        image.sizes = '(max-width: 699px) calc(100vw - 40px), min(900px, 100vw - 80px)';
      }
      image.dataset.vdResponsive = 'true';
    });
  };

  optimize();
  document.addEventListener('shopify:section:load', (event) => optimize(event.target));
})();
